'use client'

import useSWR from 'swr'

import { useDebounce } from './use-debounce'

export interface PlacePrediction {
    placeId: string
    description: string
    mainText: string
    secondaryText: string
}

interface PlacesResponse {
    predictions: PlacePrediction[]
}

async function fetchPredictions(url: string): Promise<PlacesResponse> {
    const response = await fetch(url)
    if (!response.ok) {
        throw new Error('Failed to fetch place predictions')
    }
    return response.json() as Promise<PlacesResponse>
}

export function usePlacesAutocomplete(input: string | undefined, locale = 'en-us') {
    const debouncedInput = useDebounce(input ?? '', 300)

    const { data, error, isLoading } = useSWR<PlacesResponse, Error>(
        debouncedInput.length >= 2
            ? `/api/nexus/places/autocomplete?input=${encodeURIComponent(debouncedInput)}&locale=${encodeURIComponent(locale)}`
            : null,
        fetchPredictions,
        { revalidateOnFocus: false, keepPreviousData: true },
    )

    return {
        predictions: data?.predictions ?? [],
        error,
        isLoading,
    }
}
